/** The file was automatically generated. Please do not modify manually */
import es from './online.json';
export var strings_es = es;
